export default "__VITE_ASSET__BxzV7BxZ__"